"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var BemBuilder_1 = __importDefault(require("Utils/BemBuilder"));
var c = (0, BemBuilder_1.default)("reset-popover");
var DEFAULT_RESET_STATUS = { processing: false, done: false };
function ResetPopoverContent(_a) {
    var onCancel = _a.onCancel, onReset = _a.onReset;
    return (react_1.default.createElement("div", { className: c("content") },
        react_1.default.createElement(kaleidoscope_1.Text, { size: "s" }, "Anyone with the current link will no longer have access."),
        react_1.default.createElement("div", { className: c("buttons") },
            react_1.default.createElement(kaleidoscope_1.Button, { width: "full", size: kaleidoscope_1.ButtonSize.Small, type: kaleidoscope_1.ButtonType.Secondary, onClick: onCancel }, "Cancel"),
            react_1.default.createElement(kaleidoscope_1.Button, { width: "full", size: kaleidoscope_1.ButtonSize.Small, type: kaleidoscope_1.ButtonType.Primary, onClick: onReset, isDestructive: true }, "Reset"))));
}
function ProcessingContent() {
    return (react_1.default.createElement("div", { className: c("processing-content") },
        react_1.default.createElement(kaleidoscope_1.Spinner, { size: "m" }),
        react_1.default.createElement(kaleidoscope_1.Label, { size: "m", className: c("processing-content__label") }, "Resetting Link")));
}
function AfterResetContent(_a) {
    var onDone = _a.onDone;
    return (react_1.default.createElement("div", { className: c("after-reset") },
        react_1.default.createElement("div", { className: c("after-reset__head") },
            react_1.default.createElement(icons_1.Tick, null),
            " ",
            react_1.default.createElement(kaleidoscope_1.Label, { size: "m", className: c("after-reset__head-label") }, "Link Reset")),
        react_1.default.createElement(kaleidoscope_1.Text, { align: "center", size: "s" }, "You can now copy the freshly generated collaborator link"),
        react_1.default.createElement(kaleidoscope_1.Button, { size: kaleidoscope_1.ButtonSize.Small, type: kaleidoscope_1.ButtonType.Secondary, onClick: onDone }, "Done")));
}
function ResetCollaboratorLinkButton(_a) {
    var _this = this;
    var onReset = _a.onReset;
    var _b = __read((0, react_1.useState)(false), 2), popoverOpen = _b[0], setPopoverOpen = _b[1];
    var _c = __read((0, react_1.useState)(DEFAULT_RESET_STATUS), 2), resetStatus = _c[0], setResetStatus = _c[1];
    var closePopover = (0, react_1.useCallback)(function () {
        setPopoverOpen(false);
        setResetStatusToDefault();
    }, []);
    var togglePopoverButton = (0, react_1.useCallback)(function () { return setPopoverOpen(!popoverOpen); }, [popoverOpen]);
    var onResetClicked = (0, react_1.useCallback)(function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setResetStatus(function () { return ({ processing: true, done: false }); });
                    return [4, onReset()];
                case 1:
                    _a.sent();
                    setResetStatus(function () { return ({ processing: false, done: true }); });
                    return [2];
            }
        });
    }); }, []);
    var setResetStatusToDefault = (0, react_1.useCallback)(function () { return setTimeout(function () { return setResetStatus(function () { return DEFAULT_RESET_STATUS; }); }, 500); }, []);
    return (react_1.default.createElement(kaleidoscope_1.Popover, { isOpen: popoverOpen, caret: true, button: function (props) { return (react_1.default.createElement(kaleidoscope_1.Link, __assign({}, props, { onClick: togglePopoverButton }), "Reset the link")); }, onChange: togglePopoverButton, className: c(), size: kaleidoscope_1.PopoverSize.Small },
        !resetStatus.processing && !resetStatus.done && (react_1.default.createElement(ResetPopoverContent, { onCancel: closePopover, onReset: onResetClicked })),
        resetStatus.processing && react_1.default.createElement(ProcessingContent, null),
        resetStatus.done && react_1.default.createElement(AfterResetContent, { onDone: closePopover })));
}
exports.default = ResetCollaboratorLinkButton;
